import { gql } from "@apollo/client";

export const APPLY_WORKFLOW_TEMPLATE = gql`
  mutation ApplyWorkflowInstanceTemplateChanges(
    $input: json!
    $metadata: json!
  ) {
    apply_workflow_instance_template_changes(data: $input, metadata: $metadata)
  }
`;
